<script setup lang="ts">
import { computed } from 'vue'
import { RouterView } from 'vue-router'
import SBOHeader from '@/ui/components/header/SBOHeader.vue'
import SBOSidebar from '@/ui/components/sidebar/SBOSidebar.vue'
import SBOFooter from '@/ui/components/footer/SBOFooter.vue'
import SBOServiceModeBanner from '@/ui/components/common/SBOServiceModeBanner.vue'
import { useServiceModeStore } from '@/stores/serviceMode/serviceModeStore'

const serviceModeStore = useServiceModeStore()

const isServiceModeActive = computed(() => serviceModeStore.serviceMode)

const classes = computed(() => ({
  'sbo-app-service-mode': isServiceModeActive.value
}))
</script>

<template>
  <div class="sbo-app" :class="classes">
    <SBOHeader />
    <SBOServiceModeBanner />
    <SBOSidebar />
    <main class="sbo-app__content main">
      <RouterView />
    </main>
    <SBOFooter />
  </div>
</template>

<style scoped lang="scss">
.sbo-app {
  display: grid;
  grid-template-columns: 360px 1fr;
  grid-template-rows: 72px 1fr 72px;
  grid-template-areas:
    'header header'
    'sidebar main'
    'footer footer';

  &-service-mode {
    grid-template-rows: 72px 56px 1fr 72px;
    grid-template-areas:
      'header header'
      'banner banner'
      'sidebar main'
      'footer footer';
  }

  height: 100vh;
  background: var(--nxgds-mapped-color-surface-component-page);
}

.sbo-header {
  grid-area: header;
}

.sbo-sidebar {
  grid-area: sidebar;
}

.main {
  grid-area: main;
  overflow-y: auto;
  padding: var(--nxgds-alias-spacing-lg) var(--nxgds-alias-spacing-lg) 0 0;
  color: var(--nxgds-mapped-color-text-primary);
}

.sbo-footer {
  grid-area: footer;
}

:deep(.content) {
  height: 100%;
  padding: 15px;
}
</style>
